module.exports = __webpack_public_path__ + "static/media/play-board-3.7eb44131.png";